<form [formGroup]="form">
  <div
    class="header h-[55px] flex justify-start items-center pl-[50px] mb-[18px] bg-[#F1F3F5]"
  >
    <p class="!m-0">{{ projectName }} - Pre-Qualification Questionnaire (PQQ)</p>
    <p
      class="text-[#343A40] !mt-[10px] text-[14px] font-semibold bg-white rounded-full !ml-[15px] !w-[240px] !h-[19px] flex items-center justify-center"
    >
      Submission Guideline
    </p>
  </div>

  <div class="!pl-[50px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label> Reference Number</mat-label>
          <input
            matInput
            type="text"
            formControlName="referenceNumber"
            placeholder="Reference number of PQQ"
          />
        </mat-form-field>
        <div
        *ngIf="
          form.get('referenceNumber').invalid &&
          form.get('referenceNumber').touched
        "
        class=""
      >
        <span style="color: red">Reference number is required</span>
      </div>
      
      </div>
    </div>

    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Client/Authority </mat-label>
          <input
            matInput
            type="text"
            formControlName="client_or_authority"
            placeholder="PQQ client/authority"
          />
        </mat-form-field>
        <div
          *ngIf="
            form.get('client_or_authority').invalid &&
            form.get('client_or_authority').touched
          "
          class=""
        >
          <span style="color: red">Client/Authority is required</span>
        </div>
      </div>
    </div>

    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Issue Date</mat-label>
          <input
            matInput
            [matDatepicker]="date_issue"
            formControlName="date_issue"
            placeholder="PQQ Issue Date"
          />
          <mat-datepicker-toggle matIconSuffix [for]="date_issue"></mat-datepicker-toggle>
          <mat-datepicker #date_issue startView="year" ></mat-datepicker>

        </mat-form-field>
        <div
          *ngIf="
            form.get('date_issue').invalid && form.get('date_issue').touched
          "
          class=""
        >
          <span style="color: red">PQQ Issue Date is required</span>
        </div>
      </div>
    </div>

    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label> Submission Deadline </mat-label>
          <input
            matInput
            [matDatepicker]="submissiondeadline"

            formControlName="submission_deadline"
            placeholder="PQQ Submission Deadline"
          />
          <mat-datepicker-toggle matIconSuffix [for]="submissiondeadline"></mat-datepicker-toggle>
          <mat-datepicker #submissiondeadline></mat-datepicker>

        </mat-form-field>
        <div
          *ngIf="
            form.get('submission_deadline').invalid &&
            form.get('submission_deadline').touched
          "
          class=""
        >
          <span style="color: red">PQQ Submission Deadline is required</span>
        </div>
      </div>
    </div>
  </div>

  <div
    class="!pr-[66px] !mb-[30px] !mt-[49px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
  >
    <div class="!w-[100%] flex justify-end items-center">
      <button (click)="handleBack()" type="button" class="back-btn">
        Back
      </button>
      <button
        class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
        (click)="moveToNextStep()"
      >
        Next
      </button>
    </div>
  </div>
</form>
